import React, { useEffect, useState, useRef, useCallback } from "react";
import { connect } from "react-redux";
import {
  Form,
  Select,
  Space,
  DatePicker,
  Button,
  Radio,
  Collapse,
  Modal,
  notification
} from "antd";
import {
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { v4 as uuidv4 } from "uuid"
import httpClient from "api/module/httpClient";
import { actions as SponsorsDashboardActions } from "redux/actions/dashboard-sponsors-actions";

import { searchUser } from "redux/actions/home-actions";
import { INTERNAL_LINKS } from "enum";
import {
    InputBlog,
    ImageUploadPersonalized,
    CustomInput, 
    CustomRadio,
    CustomButton,
    CustomCheckbox
} from "../../../components";
import moment from "moment";
import {getImagesCarg} from "redux/actions/blog-post-action";
import "./style.scss";

const { Option } = Select;

const ModalFormDashboardSponsors = ({
    dataSelected,
    visible=()=>{},
    finish=()=>{},
}) => {
    const [onDemandCertificateForm] = Form.useForm();
    const [funcBodyInput, setFuncBodyInput] = useState({});
    const [loading, setLoading] = useState(false)
    const [descriptions, setDescriptions] = useState('');
    const [question, setQuestion] = useState("No");
    const [bulModal, setBulModal] = useState(false)
    const [watchShrmValue, setWatchShrmValue] = useState(1);
    const [watchHrciValue, setWatchHrciValue] = useState(1);
    const [watchIhrimValue, setWatchIhrimValue] = useState(0);

    const setDashboard = async (datas) => {
        setDescriptions(datas?.description)
        onDemandCertificateForm.setFieldsValue(datas)
        setQuestion(datas?.hrCreditsBoolean ? "Yes" : "No")
    }

    useEffect(() => {
        visible({
            modal: (bul) => setBulModal(bul),
            set: (data) => setDashboard(data),            
        })
    },[])

    const resetAll = () => {
        setDescriptions('')
        if (typeof funcBodyInput.reset === "function") {funcBodyInput.reset();}
        setLoading(false);
        setBulModal(false);
        onDemandCertificateForm.resetFields();
    }


    const saveData = async (data) => {
        try{
            const response = await httpClient.post("admin/ondemand",data);
            if(response.status === 200){
                finish();
                resetAll();
                notification.success({ message: "Saved" });
            }
        }catch(er){ /* console.log(er) */ console.log(er)}
    }

    const handleSponsorDashboard = async (data) => {
        let description1 = {};
        if (funcBodyInput) {
            description1 = funcBodyInput.data();
        }
        saveData({
            ...data, 
            id: dataSelected?.onDemand?.id,
            idOnDemandCertificate: dataSelected?.id,
            description: description1.body || '',
            hrCreditsBoolean: question === "Yes" ? true : false
        })
    }

    useEffect(() => {
        if (funcBodyInput !== undefined && descriptions) {
            if (typeof funcBodyInput.data === "function") {
              const containerMap = document.createElement("div");
              containerMap.innerHTML = descriptions;
              let data = containerMap.children[0]
                ? containerMap.children[0].innerHTML
                : "";
              funcBodyInput.functionValueDefault(data);
            }
        }
    },[funcBodyInput,descriptions])

    return (
        <Modal
            className="modal-special-deliverables"
            width={"1080px"}
            footer={null}
            style={{ height: "auto", top: "0px" }}
            visible={bulModal !== false}
            onCancel={() => {
                resetAll();
                setBulModal(false);
            }}
        >
            <div className="container-dashboard-sponsor">
                <Form
                    layout="vertical"
                    form={onDemandCertificateForm}
                    onFinish={(data) => handleSponsorDashboard(data)}
                    style={{paddingTop: '40px', maxWidth: '750px', width: '750px'}}
                >
                    <Form.Item
                        label="Description"
                        name="description"
                    >
                        <InputBlog functionData={(e) => setFuncBodyInput(e)} />
                    </Form.Item>

                    <Form.Item 
                        label="What You Will Learn" 
                        name="topics"
                    >
                        <Select mode="tags"></Select>
                    </Form.Item>

                    <Form.Item
                        label="Hours needed to complete this ODCP"
                        name="timeCertificate"
                        rules={[{ required: true }]}
                    >
                        <CustomInput style={{ width: "100%" }} />
                    </Form.Item>

                    <Form.Item
                        name="hrCreditsBoolean"
                        label="HR Credits Available?"
                        rules={[{ required: false }]}
                    >
                        <CustomCheckbox
                            checked={question === "Yes" ? true : false}
                            onChange={(e) => setQuestion(e.target.checked ? "Yes" : "No")}
                        />
                    </Form.Item>
                    {question === "Yes" && (
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Form.Item
                                label="SHRM"
                                name="shrmcertificates"
                                initialValue="1"
                                rules={[{ required: false }]}
                            >
                                <CustomInput style={{ width: "100%" }} onChange={(data) => {
                                    setWatchShrmValue(data)
                                }} />
                            </Form.Item>
                            {+watchShrmValue > 0 && (
                                <Form.Item
                                    label="SHRM Code"
                                    name="shrmCode"
                                    rules={[{ required: true }]}
                                >
                                    <CustomInput style={{ width: "100%" }} />
                                </Form.Item>
                            )}
                        </Space>
                    )}
                    {question === "Yes" && (
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Form.Item
                                label="HRCI"
                                name="hrcicertificates"
                                initialValue="1"
                                rules={[{ required: false }]}
                            >
                                <CustomInput style={{ width: "100%" }} onChange={(data) => {
                                    setWatchHrciValue(data)
                                }} />
                            </Form.Item>
                            {+watchHrciValue > 0 && (
                                <>
                                    <Form.Item
                                        name="hrciCreditType"
                                        label="HRCI Credit Type"
                                    >
                                        <Radio.Group className="library-edit-form-types">
                                            <CustomRadio value="Ethics">Ethics</CustomRadio>
                                            <CustomRadio value="Business">Business</CustomRadio>
                                            <CustomRadio value="HR & Global">
                                                HR & Global
                                            </CustomRadio>
                                        </Radio.Group>
                                    </Form.Item>
                                    <Form.Item
                                        label="HRCI Code"
                                        name="hrciCode"
                                        rules={[{ required: true }]}
                                    >
                                        <CustomInput style={{ width: "100%" }} />
                                    </Form.Item>
                                </>
                            )}
                        </Space>
                    )}
                    {question === "Yes" && (
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Form.Item
                                label="IHRIM"
                                name="ihrimcertificates"
                                initialValue="0"
                                rules={[{ required: false }]}
                            >
                                <CustomInput style={{ width: "100%" }} onChange={(data) => {
                                    setWatchIhrimValue(data)
                                }} />
                            </Form.Item>
                            {+watchIhrimValue > 0 && (
                                <Form.Item
                                    label="IHRIM Code"
                                    name="ihrimCode"
                                    rules={[{ required: true }]}
                                >
                                    <CustomInput style={{ width: "100%" }} />
                                </Form.Item>
                            )}
                        </Space>
                    )}

                    <Form.Item>
                        <div style={{display:'flex',justifyContent:'center',alignItems:'center',width:'100%'}}>
                            <CustomButton
                                loading={loading}
                                onClick={() => onDemandCertificateForm.submit()}
                                text={`Save`}
                            />
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
  searchUser,
  getImagesCarg,
  ...SponsorsDashboardActions
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalFormDashboardSponsors);